import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter, BrowserRouter,useRoutes } from "react-router-dom";
import AppRoute from './config/app-route.jsx';

// bootstrap
import 'bootstrap';

// css
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.css';
import './scss/react.scss';
//import './assets/css/transparent/app.min.css';
import 'bootstrap-social/bootstrap-social.css';


const container = document.getElementById('root');
const root = createRoot(container);
function App() {
	let element = useRoutes(AppRoute);
	
	return element;
}

root.render(
  <HashRouter>
  	<App />
  </HashRouter>
);
